/* Daily Dons — buy-box.js
   Plan toggle (1/2/3 pairs), size selection, live price/CTA updates and
   purchase flow, ported from ProductBuyBox.tsx / ProductPageHero.tsx.

   Purchase flow (native Shopify):
   - checkout_live: add the selected variant + quantity to the cart via the
     Ajax Cart API, then go straight to /checkout (mirroring the original's
     cartCreate → checkoutUrl redirect). The underlying <form> posts to
     /cart/add, so with JS disabled the buyer still lands on the cart page.
   - not live (pre-launch): the CTA opens the no-charge reserve modal.
   On any Ajax failure the reserve modal opens too, so the button is never
   dead — the original's exact fallback. */
(function () {
  'use strict';

  function money(n) { return '$' + n.toFixed(2); }

  function init(box) {
    var cfg = JSON.parse(box.querySelector('[data-buy-config]').textContent);
    /* cfg: { live, plans: {single:{qty,price,retail}, ...}, variants: {SIZE: {id, available}} } */

    var state = { plan: 'pack3', size: null, busy: false };

    var priceEl = box.querySelector('[data-buy-price]');
    var compareEl = box.querySelector('[data-buy-compare]');
    var perPairEl = box.querySelector('[data-buy-perpair]');
    var shipPerk = box.querySelector('[data-buy-shipperk]');
    var perks = box.querySelector('[data-buy-perks]');
    var cta = box.querySelector('[data-buy-cta]');
    var form = box.querySelector('form[data-buy-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var qtyInput = form && form.querySelector('input[name="quantity"]');
    var modal = document.getElementById(box.getAttribute('data-reserve-modal-id'));

    function plan() { return cfg.plans[state.plan]; }

    function ctaLabel() {
      if (state.busy) return cfg.strings.busy;
      if (!state.size) return cfg.strings.chooseSize;
      var p = plan();
      var label;
      if (cfg.context === 'pdp') {
        label = p.qty === 1
          ? cfg.strings.preorder + ': ' + money(p.price)
          : cfg.strings.preorder + ' ' + p.qty + ' ' + cfg.strings.pairs + ': ' + money(p.price);
      } else {
        label = cfg.strings.preorder + ' ' + p.qty + ' ' +
          (p.qty > 1 ? cfg.strings.pairs : cfg.strings.pair) + ': ' + money(p.price);
      }
      return label;
    }

    function render() {
      var p = plan();
      if (priceEl) priceEl.textContent = money(p.price);
      if (compareEl) compareEl.textContent = money(p.retail);
      if (perPairEl) {
        perPairEl.textContent = p.qty === 1
          ? '1 pair · ' + money(p.retail) + ' at launch'
          : money(p.price / p.qty) + '/pair · ' + money(p.retail / p.qty) + '/pair at launch';
      }
      if (shipPerk) shipPerk.hidden = state.plan !== 'pack3';
      if (perks) perks.classList.toggle('is-open', state.plan === 'pack3');

      box.querySelectorAll('[data-buy-plan]').forEach(function (btn) {
        var sel = btn.getAttribute('data-buy-plan') === state.plan;
        btn.classList.toggle('is-selected', sel);
        btn.setAttribute('aria-pressed', String(sel));
      });
      box.querySelectorAll('[data-buy-size]').forEach(function (btn) {
        var sel = btn.getAttribute('data-buy-size') === state.size;
        btn.classList.toggle('is-selected', sel);
        btn.setAttribute('aria-pressed', String(sel));
      });

      if (cta) {
        cta.disabled = !state.size || state.busy;
        var p2 = plan();
        if (state.size && p2.qty > 1 && cfg.context === 'pdp' && !state.busy) {
          cta.innerHTML = '';
          cta.appendChild(document.createTextNode(ctaLabel()));
          var strike = document.createElement('span');
          strike.className = 'strike';
          strike.textContent = money(p2.retail);
          cta.appendChild(strike);
        } else {
          cta.textContent = ctaLabel();
        }
      }

      if (idInput && state.size && cfg.variants[state.size]) idInput.value = cfg.variants[state.size].id;
      if (qtyInput) qtyInput.value = plan().qty;

      /* Reserve modal plan label ("3 Pairs (M)") */
      if (modal) {
        var planLabel = modal.querySelector('[data-reserve-plan]');
        var planInput = modal.querySelector('input[name="contact[plan]"]');
        var text = state.size
          ? plan().qty + ' ' + (plan().qty > 1 ? cfg.strings.pairs : cfg.strings.pair) + ' (' + state.size + ')'
          : cfg.strings.productName;
        if (planLabel) planLabel.textContent = text;
        if (planInput) planInput.value = text;
      }
    }

    box.addEventListener('click', function (e) {
      var planBtn = e.target.closest('[data-buy-plan]');
      if (planBtn) { state.plan = planBtn.getAttribute('data-buy-plan'); render(); return; }
      var sizeBtn = e.target.closest('[data-buy-size]');
      if (sizeBtn && !sizeBtn.disabled) { state.size = sizeBtn.getAttribute('data-buy-size'); render(); return; }
    });

    function openReserve(opener) {
      if (modal && window.DDOverlays) window.DDOverlays.show(modal, opener);
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!state.size) { e.preventDefault(); return; }
        var variant = cfg.variants[state.size];
        if (!cfg.live || !variant) {
          e.preventDefault();
          openReserve(cta);
          return;
        }
        /* Ajax add → straight to checkout (the original behaviour). */
        e.preventDefault();
        state.busy = true;
        render();
        fetch(cfg.routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: plan().qty }] })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          window.location.assign(cfg.routes.checkout);
        }).catch(function () {
          state.busy = false;
          render();
          openReserve(cta);
        });
      });
    }

    render();
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-buy-box]:not([data-buy-init])')
      .forEach(function (el) { el.setAttribute('data-buy-init', '1'); init(el); });
  }
  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
